"use strict";
// functions sorted alphabetically
Object.defineProperty(exports, "__esModule", { value: true });
exports.zip = exports.shuffle = exports.partitionT = exports.partition = exports.minBy = exports.mergeBy = exports.maxBy = exports.indexBy = exports.groupBy = exports.findLastIndex = exports.diffBy = exports.distinct = exports.collectOne = exports.collect = exports.arraySame = void 0;
const arraySame = (a1, a2, eq) => a1.length === a2.length && a1.every((e, i) => eq(e, a2[i]));
exports.arraySame = arraySame;
const collect = (arr, f) => arr.map(f).filter((u) => u !== undefined);
exports.collect = collect;
const collectOne = (arr, f) => {
    for (const i of arr) {
        const u = f(i);
        if (u !== undefined) {
            return u;
        }
    }
    return undefined;
};
exports.collectOne = collectOne;
const distinct = (arr) => arr.filter((t, i) => arr.indexOf(t) === i);
exports.distinct = distinct;
const diffBy = (arr1, arr2, f) => {
    const left = [];
    const both = [];
    const obj2 = (0, exports.indexBy)(arr2, f);
    arr1.forEach((a1, i) => {
        const k = f(a1, i);
        const a2 = obj2[k];
        if (a2 === undefined) {
            left.push(a1);
        }
        else {
            both.push({ left: a1, right: a2 });
        }
        delete obj2[k];
    });
    const right = arr2.filter((a2, i) => obj2[f(a2, i)] !== undefined);
    return { left, right, both };
};
exports.diffBy = diffBy;
const findLastIndex = (arr, p) => {
    let i = arr.length - 1;
    while (i >= 0) {
        if (p(arr[i])) {
            return i;
        }
        i--;
    }
    return -1;
};
exports.findLastIndex = findLastIndex;
const groupBy = (list, getKey) => list.reduce((acc, item) => {
    const key = getKey(item);
    if (!acc[key])
        acc[key] = [];
    acc[key].push(item);
    return acc;
}, {});
exports.groupBy = groupBy;
// similar to group by but keys must be unique so values are not a list
const indexBy = (list, getKey) => list.reduce((acc, item, i) => {
    acc[getKey(item, i)] = item;
    return acc;
}, {});
exports.indexBy = indexBy;
const maxBy = (arr, f) => {
    let res = undefined;
    arr.forEach(i => {
        if (res === undefined) {
            res = i;
        }
        else if (f(res) < f(i)) {
            res = i;
        }
    });
    return res;
};
exports.maxBy = maxBy;
const mergeBy = (a1, a2, getKey, merge = (i1, i2) => ({ ...i1, ...i2 })) => {
    let others = a2.map(i2 => ({ key: getKey(i2), value: i2 }));
    const merged = a1.map(i1 => {
        const key = getKey(i1);
        const [toMerge, rest] = (0, exports.partition)(others, o => o.key === key);
        others = rest;
        return toMerge.reduce((acc, cur) => merge(acc, cur.value), i1);
    });
    return merged.concat(others.map(o => o.value));
};
exports.mergeBy = mergeBy;
const minBy = (arr, f) => {
    let res = undefined;
    arr.forEach(i => {
        if (res === undefined) {
            res = i;
        }
        else if (f(res) > f(i)) {
            res = i;
        }
    });
    return res;
};
exports.minBy = minBy;
const partition = (arr, p) => {
    const ok = [];
    const ko = [];
    arr.forEach(i => p(i) ? ok.push(i) : ko.push(i));
    return [ok, ko];
};
exports.partition = partition;
const partitionT = (arr, isT) => {
    const ts = [];
    const us = [];
    arr.forEach(i => isT(i) ? ts.push(i) : us.push(i));
    return [ts, us];
};
exports.partitionT = partitionT;
const shuffle = (array) => {
    // Fisher-Yates shuffle
    const arr = [...array]; // shallow copy of array to avoid in-place updates
    let count = arr.length;
    let rand;
    let temp;
    while (count) {
        rand = Math.random() * count-- | 0;
        temp = arr[count];
        arr[count] = arr[rand];
        arr[rand] = temp;
    }
    return arr;
};
exports.shuffle = shuffle;
const zip = (list1, list2) => list1.slice(0, list2.length).map((t, i) => [t, list2[i]]);
exports.zip = zip;
//# sourceMappingURL=array.js.map